import * as React from 'react';

interface StickyHeaderHeightContext {
  headerHeight: number;
  setHeaderHeight(height: number): void;
}

const StickyHeaderHeightContext = React.createContext<StickyHeaderHeightContext>(
  undefined as any,
);

const useStickyHeaderHeight = () => {
  const context = React.useContext(StickyHeaderHeightContext);
  if (!context) {
    throw new Error(
      'useStickyHeaderHeight must be used within StickyHeaderHeightProvider',
    );
  }
  return context;
};

const StickyHeaderHeightProvider: React.FC = ({ children }) => {
  const [headerHeight, setHeaderHeight] = React.useState<number>(0);

  return (
    <StickyHeaderHeightContext.Provider
      value={{ headerHeight, setHeaderHeight }}
    >
      {children}
    </StickyHeaderHeightContext.Provider>
  );
};

export { StickyHeaderHeightProvider, useStickyHeaderHeight };
